import { Link } from "react-router-dom";
import { ArrowRight, Award, Users, Clock, HeartHandshake, Target, Sparkles } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { SITE, AFFILIATION } from "@/data/site";
import { Seo } from "@/components/Seo";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1517048676732-d65bc937f952?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

const VALUES = [
  { icon: Award, title: "Esperienza", desc: "Oltre 25 anni sul mercato del gambling con innovazione, dedizione e competenza." },
  { icon: Users, title: "Community", desc: "Migliaia di clienti italiani ci hanno eletto punto di riferimento per l'online gaming." },
  { icon: Clock, title: "Affidabilità", desc: "Introiti certi e verificabili, accreditati sul tuo conto corrente ogni 30 giorni." },
  { icon: HeartHandshake, title: "Supporto", desc: "Assistenza esperta 24/7 tramite i canali di contatto più immediati." },
  { icon: Target, title: "Selezione", desc: "Solo i migliori marchi del settore, italiani e internazionali, sulla nostra piattaforma." },
  { icon: Sparkles, title: "Innovazione", desc: "Una piattaforma veloce, semplice e intuitiva, sempre aggiornata alle ultime novità." },
];

export default function ChiSiamo() {
  return (
    <div data-testid="chi-siamo-page">
      <Seo
        title="Chi siamo | TopAffiliation"
        description="Leader italiano dell'affiliazione su gambling da oltre 25 anni: piattaforma veloce, supporto 24/7 e le migliori condizioni economiche del mercato."
        path="/chi-siamo"
      />
      <section className="relative pt-36 pb-16 md:pt-44 md:pb-20 overflow-hidden">
        <div className="absolute inset-0 -z-10 grid-overlay opacity-50" />
        <div className="absolute -z-10 top-20 left-1/4 h-64 w-64 rounded-full bg-brand-red/15 blur-3xl" />
        <div className="container-x">
          <Reveal>
            <span className="eyebrow">Chi siamo</span>
            <h1 className="mt-5 font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold max-w-4xl leading-[1.05]">
              Il leader del mercato italiano dell'<span className="text-gradient">affiliazione</span> su gambling
            </h1>
            <p className="mt-6 text-lg text-white/70 max-w-2xl leading-relaxed">
              Da oltre 25 anni proponiamo ai nostri clienti le migliori condizioni per
              strategie di affiliazione di qualità, con una piattaforma veloce, semplice e intuitiva.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="pb-8">
        <div className="container-x grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          <Reveal>
            <div className="relative">
              <div className="absolute -inset-4 -z-10 rounded-3xl bg-brand-rose/10 blur-2xl" />
              <img
                src={ABOUT_IMG}
                alt="Il team di TopAffiliation"
                className="rounded-2xl border border-white/10 w-full object-cover aspect-[4/3]"
              />
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="space-y-5 text-white/70 leading-relaxed">
              <p>
                Con un'assistenza professionale 24/7, l'accesso ai migliori programmi di
                affiliation e tutte le condizioni economiche che hai sempre desiderato,
                <strong className="text-white"> {SITE.name}</strong> è il miglior modo per
                guadagnare facilmente con le affiliazioni.
              </p>
              <p>
                Puoi costruire una rendita che ti consentirà di arrotondare le tue entrate,
                o di costruire un vero e proprio business sostenibile. E se non hai
                esperienza di marketing e conversioni online, non temere: i nostri esperti
                hanno predisposto guide complete e gratuite che ti condurranno passo dopo
                passo verso una strategia autonoma su questo mercato redditizio.
              </p>
              <p>
                Negli anni migliaia di clienti italiani hanno premiato i nostri servizi
                eleggendoli come punto di riferimento per l'online gaming.
                <strong className="text-white"> Cosa aspetti ad essere il prossimo?</strong>
              </p>
              <a
                href={AFFILIATION.signup}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-glow inline-flex items-center gap-2 rounded-full bg-brand-red px-6 py-3 text-sm font-semibold text-white hover:bg-brand-redDark hover:scale-[1.03]"
              >
                Iscriviti subito senza impegno <ArrowRight className="h-4 w-4" />
              </a>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="py-20 md:py-28">
        <div className="container-x">
          <Reveal>
            <h2 className="font-heading text-3xl md:text-4xl font-bold">I nostri valori</h2>
          </Reveal>
          <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {VALUES.map((v, i) => (
              <Reveal key={v.title} delay={(i % 3) * 0.08}>
                <div className="card-surface p-8 h-full hover:border-brand-red/50 transition-colors">
                  <span className="grid place-items-center h-12 w-12 rounded-xl bg-brand-red/10 text-brand-red">
                    <v.icon className="h-6 w-6" />
                  </span>
                  <h3 className="mt-6 font-heading text-xl font-semibold">{v.title}</h3>
                  <p className="mt-3 text-white/60 leading-relaxed">{v.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
